query GetAudiencesForEntityList(
    $limit: Int!
    $archived: Boolean
    $cursor: String
    $sort: AudienceSortType!
    $search: String
    $creatorUserId: String
    $lastUpdatedTime: String
    $audienceTypeFilter: AudienceTypeFilter
) {
    audiences(
        first: $limit
        archived: $archived
        after: $cursor
        sort: $sort
        search: $search
        creatorUserId: $creatorUserId
        modifiedSinceTime: $lastUpdatedTime
        audienceTypeFilter: $audienceTypeFilter
    ) {
        totalCount
        edges {
            cursor
            node {
                id
                name
                htmlUrl
                htmlUrlPath
                htmlUrlPathForList
                membershipStats {
                    totalCount {
                        value
                        suffix
                        prefix
                        formatted
                    }
                }
                createdTime
                isRecentlyCreated
                description
            }
        }
    }
}
